import React, { useState, useMemo } from "react";
import api from "../api/axiosAuth";
import { useAuth } from "../context/AuthContext";
import '../style/CrearInstitucion.css';

const CrearInstitucion = () => {
  const { user, role } = useAuth();

  // 🔥 FIX REAL (usando tu AuthContext correcto)
  const isDev = useMemo(() => role === "desarrollador", [role]);

  const [form, setForm] = useState({
    nombre: "",
    codigo_dane: "",
    direccion: "",
    telefono: "",
    email: "",
    municipio: "",
    departamento: "",
    ciudad: "",
    nit: "",
    logo: "",
    logo_url: "",
    rector_usuario: "",
    rector_password: "",
    rector_nombre: "",
    rector_apellido: ""
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();

    // validación básica
    if (
      !form.nombre.trim() ||
      !form.rector_usuario.trim() ||
      !form.rector_password.trim() ||
      !form.rector_nombre.trim() ||
      !form.rector_apellido.trim()
    ) {
      alert("⚠️ Datos obligatorios faltantes.");
      return;
    }

    setLoading(true);

    try {
      const payload = Object.fromEntries(
        Object.entries(form).map(([k, v]) => [
          k,
          v?.toString().trim() || null
        ])
      );

      await api.post("/instituciones/crear-completa", payload);

      alert("🏫 Institución y Rector creados correctamente");

      // reset limpio
      setForm({
        nombre: "",
        codigo_dane: "",
        direccion: "",
        telefono: "",
        email: "",
        municipio: "",
        departamento: "",
        ciudad: "",
        nit: "",
        logo: "",
        logo_url: "",
        rector_usuario: "",
        rector_password: "",
        rector_nombre: "",
        rector_apellido: ""
      });

    } catch (err) {
      console.error("ERROR:", err);
      alert(err.response?.data?.msg || "Error al crear institución");
    } finally {
      setLoading(false);
    }
  };

  // 🔐 bloqueo correcto
  if (!isDev) {
    return (
      <div className="alerta-error">
        ❌ No tienes permiso para acceder a este módulo
      </div>
    );
  }

  return (
    <div className="form-container">
      <h2>🏫 Crear Institución + Rector</h2>

      <form onSubmit={handleSubmit} className="form-box">

        {[
          "nombre",
          "codigo_dane",
          "direccion",
          "telefono",
          "email",
          "municipio",
          "departamento",
          "ciudad",
          "nit"
        ].map((campo) => (
          <div key={campo} className="form-group">
            <label>{campo.toUpperCase()}</label>
            <input
              type="text"
              name={campo}
              value={form[campo]}
              onChange={handleChange}
              required={campo === "nombre"}
            />
          </div>
        ))}

        <h3>Datos del Rector *</h3>

        {[
          "rector_nombre",
          "rector_apellido",
          "rector_usuario",
          "rector_password"
        ].map((campo) => (
          <div key={campo} className="form-group">
            <label>{campo.replace("rector_", "").toUpperCase()}</label>
            <input
              type={campo === "rector_password" ? "password" : "text"}
              name={campo}
              value={form[campo]}
              onChange={handleChange}
              required
            />
          </div>
        ))}

        <button disabled={loading}>
          {loading ? "Guardando..." : "Crear Institución + Rector"}
        </button>
      </form>
    </div>
  );
};

export default CrearInstitucion;
